import { createSlice } from "@reduxjs/toolkit";
import { uploadFileParty } from "../api/fileUpload";

interface ProfileState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
  loadImage: boolean;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
  loadImage: false
} as ProfileState;
 export const profileSlice = createSlice({
    name: 'party',
    initialState,
    reducers:{
        resetFile: () => initialState,
      },
    extraReducers(builder) {
        builder
          .addCase(uploadFileParty.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(uploadFileParty.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.loadImage = true;
            }
          })
          .addCase(uploadFileParty.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
              state.loadImage = false;
            }
          })
    }
 })

 export const { resetFile } = profileSlice.actions;

export default profileSlice.reducer;
